
//
const createElement = require('./utils/createElement.js');

//
addActionToRemoveButtons();
calculateTotalFee();

//add new address
const template = document.querySelector('script[id="tpl-address"]');

if (template) {

    //
    const addressWrapper = document.querySelector('[data-name="tenants-addresses"]');

    //
    const addButtonWrapper = document.querySelector('[data-name="add-address-button-wrapper"]');
    const addAddressButton = document.querySelector('button[data-action="add-address"]')

    //
    if (addressWrapper !== null && addButtonWrapper !== null && addAddressButton !== null) {
        addAddressButton.addEventListener('click', (event) => {

            //
            const index = document.querySelectorAll('div[data-name="address"]').length;

            //
            const address = createElement('div', {
                'data-name' : 'address',
                'data-id'   : index,
            });

            //
            address.innerHTML = template.innerHTML;

            //
            addressWrapper.append(address);

            //
            addActionToRemoveButtons();
            resetIDS();
            calculateTotalFee();

            //if there are 3 or more addresses added - hide the add button
            addButtonWrapper.toggleAttribute('hidden', (document.querySelectorAll('div[data-name="address"]').length >= addressWrapper.dataset.maxAllowedAddresses));

        });
    }

}

//add action to all address removal buttons
function addActionToRemoveButtons(){

    //
    const addresses = document.querySelectorAll('div[data-name="address"]');

    //
    for (let i=0; i<addresses.length; i++) {

        //
        if ((removeButton = addresses[i].querySelector('button[data-name="remove"]')) != null) {

            //
            if (removeButton.dataset.event == 'true') {
                return;
            }

            //
            removeButton.addEventListener('click', (event) => {

                //
                removeButton.setAttribute('event', 'true');
                addresses[i].remove();
                resetIDS();
                calculateTotalFee();

                //if there are less than 3 addresses, show the add address button
                const addButtonWrapper = document.querySelector('[data-name="add-address-button-wrapper"]');
                addButtonWrapper.classList.toggle('hidden', (document.querySelectorAll('div[data-name="address"]').length >= 3));

            });

        }

    }

}

//change the ids for all input and label within each address div
function resetIDS() {

    //
    const addresses = document.querySelectorAll('div[data-name="address"]');

    //
    if (!addresses) {
        return;
    }

    //
    for (let i=0; i<addresses.length; i++) {

        //
        addresses[i].querySelectorAll('input, label').forEach((item) => {

            //
            if (item.tagName == 'INPUT') {
                item.name = item.name.replace(/([0-9])$/, i);
                item.id   = item.id.replace(/([0-9])$/, i);
            }

            //
            if (item.tagName == 'LABEL') {
                item.setAttribute('for', item.getAttribute('for').replace(/([0-9])$/, i));
            }

        });

        //
        if ((addressCount = document.querySelector('form input[name="creditcheck_address_count"]')) != null) {
            addressCount.setAttribute('value', addresses.length);
        }

    }
}

function calculateTotalFee() {

    //
    const addresses = document.querySelectorAll('div[data-name="address"]');

    //
    if (!addresses) {
        return;
    }

    //
    if ((creditcheckFee = document.querySelector('span[data-name="creditcheck-total-fee"]')) != null) {
        creditcheckFee.innerText = (12 + ((addresses.length - 1) * 1));
    }

}
